import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReturnsService {

  constructor(private readonly http:HttpClient) { }

  saveReturnToDealerDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-out/bulk-return-to-dealer';
    return this.http.post(url,payload);
  }

  saveReturnFromCustomerDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-in/bulk-return-from-customer';
    return this.http.post(url,payload);
  }

  stockReturnFromCustomer(payload: any) {
    let url = environment.BASE_URL + '/v1/stock-in/bulk-return-from-customer-with-settlement';
    return this.http.post(url, payload);
  }

  saveReturnReplaceDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-in/bulk-return-replace';
    return this.http.post(url,payload);
  }

  saveExchangeDetails(payload: any) {
    let url = environment.BASE_URL + '/v1/stock-in/bulk-return-replace-with-settlement';
    return this.http.post(url, payload);
  }
}
